export default (date) => {
    return (new Date(date))
        .toLocaleDateString("en-IN", {
            day: "2-digit", month: "2-digit", year: "numeric"
        }).replace(/\//g, "-");
};

export const toLocaleDateString = (isoTimeStamp = "") => {
    if (!isoTimeStamp) return "";
    const formatted = new Date(isoTimeStamp).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
    });

    return formatted;
};
